import { render } from "./ActivityDetailView.vue?vue&type=template&id=e01e65a0&scoped=true"
import script from "./ActivityDetailView.vue?vue&type=script&lang=js"
export * from "./ActivityDetailView.vue?vue&type=script&lang=js"

import "./ActivityDetailView.vue?vue&type=style&index=0&id=e01e65a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e01e65a0"]])

export default __exports__